import { jwtDecode } from 'jwt-decode'
import { logger } from './logger'

interface JwtPayload {
  sub: string
  email: string
  exp: number
  nome: string
  tipo: string
  permissoes?: string[]
}

export function decodeJwtPayload(token: string): JwtPayload | null {
  try {
    const decoded = jwtDecode<JwtPayload>(token)
    return decoded
  } catch (error) {
    logger.error('Erro ao decodificar o token JWT', error as Error)
    return null
  }
}

export function TokenExpirado(token: string): boolean {
  try {
    const decoded = jwtDecode<JwtPayload>(token)
    if (!decoded.exp) return true
    const agora = Date.now() / 1000
    return decoded.exp < agora
  } catch (error) {
    logger.error('Erro ao verificar expiracao do token', error as Error)
    return true
  }
}

export function VerificarTipoAcesso(token: string): string | null {
  try {
    const decoded = jwtDecode<JwtPayload>(token)
    return decoded.tipo || null
  } catch {
    return null
  }
}

export function VerificarEmail(token: string): string | null {
  try {
    const decoded = jwtDecode<JwtPayload>(token)
    return decoded.email || null
  } catch {
    return null
  }
}

export function VerificarNome(token: string): string | null {
  try {
    const decoded = jwtDecode<JwtPayload>(token)
    return decoded.nome || null
  } catch {
    return null
  }
}
